<template>
  <v-row>
    <v-col cols="auto" class="mr-1">
      <v-btn
        link
        small
        outlined
        color="primary"
        class="ml-2"
        :to="{
          name: `${link}`
        }"
        :loading="loading"
        :disabled="disabled"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-col>
    <v-col>
      <h4>
        {{ title }}
      </h4>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FormHeader',
  props: {
    loading: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: '/'
    },
    title: {
      type: String,
      default: null
    }
  }
}
</script>
